// @ts-nocheck
import { inputStyles } from "@store/Themes/common/mixins/formField";

export default {
    defaultProps: {
        cssOverrides: {
            inputSelect: inputStyles(),
        },
    },
};
